import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import Element from 'element-ui'
import localeEn from 'element-ui/lib/locale/lang/en'
import localeEs from 'element-ui/lib/locale/lang/es'
import localePt from 'element-ui/lib/locale/lang/pt-br'

Vue.use(VueI18n)

function loadLocaleInfo () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)

  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      switch (locale) {
        case 'en':
          messages[locale] = { ...locales(key), ...localeEn }
          return
        case 'es':
          messages[locale] = { ...locales(key), ...localeEs }
          return
        case 'pt':
          messages[locale] = { ...locales(key), ...localePt }
      }
    }
  })
  return { id: locales.id, messages }
}

const { id, messages } = loadLocaleInfo()

const i18n = new VueI18n({
  locale: 'en',
  messages
})
// Codigo que hace dinámico los idiomas en componentes de Element
Vue.use(Element, {
  i18n: (id, messages) => i18n.t(id, messages)
})

if (module.hot) {
  module.hot.accept(id, () => {
    const { messages } = loadLocaleInfo()
    Object.keys(messages).forEach(locale => {
      i18n.setLocaleMessage(locale, messages[locale])
    })
  })
}

export default i18n
